/**
 * Mirrors the backend FileValidationGuard.IsSupportedForProcessing decision (#242):
 * only PDF, JPEG and PNG run through the AI pipeline (classification/OCR/extraction/
 * thumbnail). Any other type is stored as-is and marked `Finished` without processing.
 * The UI uses this to show a "stored only / not processed" indicator so such documents
 * are not mistaken for fully processed ones.
 */
const PROCESSABLE_MIME_TYPES = new Set(['application/pdf', 'image/jpeg', 'image/png']);

/** True if the given MIME type is processed by the AI pipeline (PDF/JPEG/PNG). */
export function isProcessableType(mimeType: string | undefined | null): boolean {
  return !!mimeType && PROCESSABLE_MIME_TYPES.has(mimeType.toLowerCase());
}
